<!--
 * @Description: 组织架构（客户区域）级联选择组件
 * @Author: mdb
 * @Date: 2022-08-10 14:30:57
 * @LastEditTime: 2023-06-21 10:26:52
 * @LastEditors: cxh
-->
<template>
  <CustomerAreaCascaderText v-if="view" v-bind="attrs" :deptInfoId="deptInfoId" :appId="appId" :view="view" />
  <CosCascader v-else v-bind="attrs" :options="customerAreaEnum" :placeholder="t('common.pleaseSelect')" allowClear />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import useHook from './useHook'
import CustomerAreaCascaderText from './CustomerAreaCascaderText.vue'
const { t } = useI18n()

const props = defineProps<{
  appId: 'cos_fbu' | 'cos_ofbu' | 'cos_lbu'
  deptInfoId?: string
  type?: 'search'
  view?: boolean
  multiple?: boolean
}>()
const { customerAreaEnum } = useHook(props.appId, props.deptInfoId)

const attrs = computed(() => ({
  type: props.type,
  changeOnSelect: true,
  multiple: (props.type && props.appId === 'cos_lbu') || props.multiple, // 只有 search 类型 且为 cos_lbu 才支持多选
  maxTagCount: props.appId === 'cos_lbu' ? 'responsive' : undefined,
  fieldNames: props.appId === 'cos_lbu' ? { label: 'name', value: 'id' } : { label: 'label', value: 'id' }
}))
</script>
<script lang="ts">
export default { name: 'CustomerAreaCascader' }
</script>

<style scoped></style>
